import { Injectable } from '@angular/core';
import { ParcelHistory } from '../models/parcelhistory';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class ParcelhistoryService {
  public currentParcelHistorySubject: BehaviorSubject<ParcelHistory[]>;
  public currentParcelHistory: Observable<ParcelHistory[]>;
  public dataSource: MatTableDataSource<ParcelHistory>;
  public language: number;
  public loadingInProgress: BehaviorSubject<boolean>;

  constructor(private apiProvider: ApiProvider) {
    this.currentParcelHistorySubject = new BehaviorSubject<ParcelHistory[]>(
      null
    );
    this.loadingInProgress = new BehaviorSubject<boolean>(null);
  }

  public get currentSectorValue(): ParcelHistory[] {
    return this.currentParcelHistorySubject.value;
  }

  public getLoadingInProgress() {
    return this.loadingInProgress.value;
  }

  public setLoadingInProgress(value: boolean) {
    this.loadingInProgress.next(value);
  }

  async initialiseParcel(parcelID: number) {
    this.setLoadingInProgress(true);
    this.apiProvider.GetParcelHistoriesInfo(parcelID, this.language).subscribe(
      (parcelHistories: ParcelHistory[]) => {
        this.currentParcelHistorySubject = new BehaviorSubject<ParcelHistory[]>(
          parcelHistories
        );
        this.currentParcelHistorySubject.next(parcelHistories);
        this.currentParcelHistory = this.currentParcelHistorySubject.asObservable();
        this.dataSource = new MatTableDataSource<ParcelHistory>(
          parcelHistories
        );
        this.setLoadingInProgress(false);
      },
      (err: HttpErrorResponse) => {
        this.currentParcelHistorySubject.next(null);
        this.setLoadingInProgress(false);
      }
    );
  }

  clearParcel() {
    this.currentParcelHistorySubject.next(null);
    this.dataSource = null;
    this.setLoadingInProgress(false);
  }
}
